// SYNCHRONOUS ACTIONS
export const LOAD_GRID = {
  REQUEST: 'LOAD_GRID',
  SUCCESS: 'LOAD_GRID_SUCCESS',
  FAILURE: 'LOAD_GRID_FAILURE'
};

export const CHANGE_FILTER = 'CHANGE_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const SAVE_FILTER = 'SAVE_FILTER';
export const RESET_FILTERS = 'RESET_FILTERS';
export const UPDATE_UNAPPLIED_FILTERS = 'UPDATE_UNAPPLIED_FILTERS';

export const SAVE_COLUMN = 'SAVE_COLUMN';
export const SAVE_SORT = 'SAVE_SORT';

export const CHANGE_SAVED_VIEW = 'CHANGE_SAVED_VIEW';
export const ADD_USER_VIEW = 'ADD_USER_VIEW';
export const LOAD_SAVED_VIEW = 'LOAD_SAVED_VIEW';

// ASYNCHRONOUS ACTIONS
export const LOAD_MORE = {
  REQUEST: 'LOAD_MORE_REQUEST',
  SUCCESS: 'LOAD_MORE_SUCCESS',
  FAILURE: 'LOAD_MORE_FAILURE'
};
